import script from "./QChangelogItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./QChangelogItem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
